import React, { useRef } from "react";
import { MDBBtn, MDBIcon, MDBSideNav, MDBSideNavMenu } from "mdb-react-ui-kit";
import Session from "./FilterSideNavItems/Session/Session";
import Legislature from "./FilterSideNavItems/Legislature/Legislature";
import Status from "./FilterSideNavItems/Status/Status";
import Chamber from "./FilterSideNavItems/Chamber/Chamber";
import Party from "./FilterSideNavItems/Party/Party";

const FilterSideNav = ({
  filterSideNavIsOpen,
  setFilterSideNavIsOpen,
  userSelectedSession,
  setUserSelectedSession,
  userSelectedLegislature,
  setUserSelectedLegislature,
  userSelectedStatus,
  setUserSelectedStatus,
  userSelectedChamber,
  setUserSelectedChamber,
  userSelectedParty,
  setUserSelectedParty,
  availableParties,
}) => {
  const container = useRef(null);
  const handleClearFilters = () => {
    setUserSelectedStatus("All");
    setUserSelectedChamber([]);
    setUserSelectedParty([]);
  };

  return (
    <MDBSideNav
      mode="side"
      open={filterSideNavIsOpen}
      absolute
      contentRef={container}
      className="bg-light h-100 position-fixed"
    >
      <MDBSideNavMenu>
        <li className="d-flex justify-content-between align-items-middle my-3">
          <h4 className="fw-bold">
            <MDBIcon fas icon="filter" /> Filters
          </h4>
          <MDBBtn
            className="btn-close"
            color="none"
            aria-label="Close"
            onClick={() => setFilterSideNavIsOpen(false)}
          />
        </li>
        <Legislature
          userSelectedLegislature={userSelectedLegislature}
          setUserSelectedLegislature={setUserSelectedLegislature}
        />
        <Session
          userSelectedSession={userSelectedSession}
          setUserSelectedSession={setUserSelectedSession}
        />
        <Chamber
          userSelectedChamber={userSelectedChamber}
          setUserSelectedChamber={setUserSelectedChamber}
        />
        <Party
          userSelectedParty={userSelectedParty}
          setUserSelectedParty={setUserSelectedParty}
          availableParties={availableParties}
        />
        <Status
          userSelectedStatus={userSelectedStatus}
          setUserSelectedStatus={setUserSelectedStatus}
        />
      </MDBSideNavMenu>

      {/* Clear Filters Button */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          padding: "1rem",
          borderTop: "1px solid #dee2e6",
        }}
      >
        <MDBBtn color="dark" className="w-100" onClick={handleClearFilters}>
          Clear Filters
        </MDBBtn>
      </div>
    </MDBSideNav>
  );
};

export default FilterSideNav;
